import { View } from "binder"
import { IconElement } from "./icon-viewModel"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";


export class IconView extends FormBuilderComponentView<IconElement>{
    GetViewUniqueId(): string {
        return "V-3352C036-F058-4968-91CD-6AC83CF7A089"
    }
    loadHtml(): string {
        let element = require('./icon.html').default;
        let style = require('./icon.less');
        return element;
    }
    constructor() {
       super();
    }

    public set IconClass(v: string) { this._IconClass = v; } public get IconClass(): string { return this._IconClass;} private _IconClass: string;
}
